// extracted by mini-css-extract-plugin
module.exports = {"panels":"Panels_panels__1QOCW","panel":"Panels_panel__3c11R"};